const AzureConstant = {
    LOCAL_APP: 'https://localhost:44342/',
    DEV_APP: 'app-letsgo-dev-001.azurewebsites.net',
    QA_APP: 'app-letsgo-qa-001.azurewebsites.net',
    CT_APP: 'app-letsgo-ct-001.azurewebsites.net',
    PROD_APP: 'letsgo.nba.com',
    TENANT_ID: 'e898ff4a-4b69-45ee-a3ae-1cd6f239feb2',
    DEV_CLIENT: 'd67c84dd-44f6-4544-9e30-ee1b8cda235c',
    QA_CLIENT: '43b7db89-8216-4adc-a244-dfd02275e96c',
    CT_CLIENT: '29b32369-f3d2-4323-9613-3d7a3f23f30d',
    PROD_CLIENT: '40331c32-2a53-406f-a721-2c6637c5c18b',
    OTHER_CAPTCHA_SITE_KEY: process.env.REACT_APP_OTHER_CAPTCHA_SITE_KEY,
    PROD_CAPTCHA_SITE_KEY: process.env.REACT_APP_PROD_CAPTCHA_SITE_KEY,
};

export default AzureConstant;